import { sanitizeURL } from '../utils/urlUtils';

/**
 * Removes double slashes (//) from url (but not the one after the protocol)
 * @param {string} url - url to filter
 * @returns {string} - The sanitized url
 */
export function sanitizeURLFilter(url) {
    const requireTrailingSlashes = _.get(this.ctx, 'core.constants.urlsRequireTrailingSlash', false);

    return sanitizeURL(url, requireTrailingSlashes);
}

export default sanitizeURLFilter;
